import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { IWlComponentCanDeactivateRoute } from './icomponent-can-deactivate-route';

/**
 * Deactivate guard for router. From Angular2 tutorial.
 *
 * If added to a route in app.routes.ts and the component for that route implements ICanComponentDeactivateRoute
 * then that component can do stuff before the navigation and even cancel navigation.
 *
 * P.S. Guards are services.
 */
@Injectable()
export class WlCanDeactivateRouteGuard implements CanDeactivate<IWlComponentCanDeactivateRoute> {
  /**
   * runs after navigation requested, but before actually navigating from a component
   * @param component
   * @param routeSnapshot
   * @param stateSnapshot
   * @returns true or an observable or promise that finishes with true to continue allow navigation. false to cancel.
   */
  public canDeactivate(
    component: IWlComponentCanDeactivateRoute,
    routeSnapshot: ActivatedRouteSnapshot,
    stateSnapshot: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return component.canNavigateAway ? component.canNavigateAway(routeSnapshot, stateSnapshot) : true;
  }
}
